import { Link } from 'react-router-dom';
import { To } from 'history';
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';
import { APP_DEFAULT_PATH } from 'config';
import LogoIcon from './LogoIcon';
import LogoMain from './LogoMain';

interface Props {
    reverse?: boolean;
    isIcon?: boolean;
    sx?: SxProps;
    to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={sx}>
        {isIcon ? <LogoIcon /> : <LogoMain reverse={reverse} />}
    </ButtonBase>
);

export default LogoSection;
